import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_29xxo8ggi7: FaireBrandEntity = {
  token: "b_29xxo8ggi7",
  type: "brand",
  name: "Swanson Christian Products",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb3441f30ca109242bd68bd70c05c0967b86ce1bb5699654e7bb34b3a894a1d9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dea3c9f06bed14cda299dea4ccd8d6a1e30e26c1cd2d1753fc15dcff3c3d3ab2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/eb3441f30ca109242bd68bd70c05c0967b86ce1bb5699654e7bb34b3a894a1d9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dea3c9f06bed14cda299dea4ccd8d6a1e30e26c1cd2d1753fc15dcff3c3d3ab2.png",
  location: "Murfreesboro, TN, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 116,
  isTopShop: true,
  isInsider: true,
  description:
    "Established in 1935, Swanson Products has served retailers for over 90 years. Our mission is to make the name of God known through Gifts of Eternal Value! We are a family-owned and operated business in Middle Tennessee! Thank you for partnering with us in our mission to Make Him Known.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:02.767Z",
    importedBy: "entity-db-cli",
  },
};
